import * as React from 'react';
import * as acl from 'common/utils/acl';
import * as qs from 'qs';

import { EntityActions, EntityType } from 'common/entity';
import { Route, RouteComponentProps } from 'react-router-dom';

import { AppState } from 'common/models/AppState';
import { Page } from 'common/components/layout/Page';
import { Search } from 'common/components/Search';
import { SummitRegistrant } from 'common/api/models/SummitRegistrant';
import { SummitRegistrantsDialog } from './SummitRegistrantDialog';
import { SummitRegistrantsTable } from './SummitRegistrantsTable';
import { getFilterTerms, stripQueryTerms } from '../../common/utils/search';
// import { Filters } from 'common/components/Filters';
import { Feature } from 'common/features/Feature';
import { canViewBadges } from 'common/features/canViewBadges';

export interface SummitRegistrantsProps {
  appState: AppState;
  entityActions: EntityActions;
}

export interface SummitRegistrantSearchQuery {
  q: string;
  type?: string;
}
export interface SummitRegistrantsState {
  error?: string;
  editSummitRegistrant?: SummitRegistrant;
}

export const NEW_TAG = {
  description: '',
  name: '',
  type: 'BRAND',
};

export const TAG_TYPES = [
  { label: 'All', value: '' },
  { label: 'Brand', value: 'BRAND' },
  { label: 'Category', value: 'CATEGORY' },
  { label: 'Product', value: 'PRODUCT' },
  { label: 'Service', value: 'SERVICE' },
  { label: 'Style', value: 'STYLE' },
  { label: 'Certification', value: 'CERTIFICATION' },
  { label: 'Internal', value: 'INTERNAL' },
  { label: 'Backsplash Material', value: 'BACKSPLASH_MATERIAL' },
  { label: 'Bathtub', value: 'BATHTUB' },
  { label: 'Bathroom Type', value: 'BATHROOM_TYPE' },
  { label: 'Budget', value: 'BUDGET' },
  { label: 'Cabinet Finish', value: 'CABINET_FINISH' },
  { label: 'Cabinet Style', value: 'CABINET_STYLE' },
  { label: 'Color', value: 'COLOR' },
  { label: 'Counter Material', value: 'COUNTER_MATERIAL' },
  { label: 'Floor Color', value: 'FLOOR_COLOR' },
  { label: 'Floor Material', value: 'FLOOR_MATERIAL' },
  { label: 'Islands', value: 'ISLANDS' },
  { label: 'Kitchen Layout', value: 'KITCHEN_LAYOUT' },
  { label: 'Kitchen Type', value: 'KITCHEN_TYPE' },
  { label: 'Shower Enclosure', value: 'SHOWER_ENCLOSURE' },
  { label: 'Shower Type', value: 'SHOWER_TYPE' },
  { label: 'Sink', value: 'SINK' },
  { label: 'Size', value: 'SIZE' },
  { label: 'Toilet', value: 'TOILET' },
  { label: 'Wall Color', value: 'WALL_COLOR' },
  { label: 'Room', value: 'ROOM' },
  { label: 'Wall Tile Color', value: 'WALL_TILE_COLOR' },
  { label: 'Wall Tile Material', value: 'WALL_TILE_MATERIAL' },
  { label: 'Job Type', value: 'JOB_TYPE' },
  { label: 'Job Experience', value: 'JOB_EXPERIENCE' },
];

export class SummitRegistrants extends React.Component<
  SummitRegistrantsProps & RouteComponentProps<{}>,
  SummitRegistrantsState
> {
  state: SummitRegistrantsState = {};
  filterNames = ['type'];
  filters = [
    {
      name: 'type',
      label: 'Type',
      options: canViewBadges(Feature.badges, this.props.appState.config, this.props.appState.user)
        ? [...TAG_TYPES, { label: 'Badge', value: 'BADGE' }]
        : TAG_TYPES,
    },
  ];

  getQuery() {
    const q = qs.parse(this.props.location.search.substring(1)).q;
    return q !== undefined ? q : '';
  }

  handleSearch = (value: string) => {
    const query = this.getQuery();
    const filterValue = getFilterTerms(query, this.filterNames);
    const newSearchQuery = (value + ' ' + filterValue).trim();
    this.handleQuery(newSearchQuery);
  };

  handleQuery = (query: string) => {
    if (!query) {
      this.props.history.push(this.props.match.url);
    } else {
      this.props.history.push(this.props.match.url + '?' + qs.stringify({ q: query }));
    }
  };

  handleAdd = () => {
    this.setState({ editSummitRegistrant: NEW_TAG as any });
  };

  handleEdit = (editSummitRegistrant: SummitRegistrant) => {
    this.setState({ editSummitRegistrant });
  };

  handleCancelDialog = () => {
    this.setState({ editSummitRegistrant: undefined });
  };

  handleSaveDialog = (id: string) => {
    this.props.entityActions.refetch(EntityType.TAG, id);
    this.setState({ editSummitRegistrant: undefined });
  };

  render() {
    const query = this.getQuery();
    const searchQuery = stripQueryTerms(query, this.filterNames);
    return (
      <div>
        {this.state.error && (
          <div className="alert alert-danger" style={{ marginTop: 20 }}>
            {this.state.error}
          </div>
        )}

        <Route
          path="/summitRegistrants"
          exact={true}
          render={(props: RouteComponentProps<{}>) => (
            <Page
              title="SummitRegistrants"
              primaryAction={{
                shouldRender: acl.isManager(this.props.appState.user!),
                onClick: this.handleAdd,
                label: 'Add SummitRegistrant',
              }}
            >
              <div className="card card-responsive">
                <div className="p-3 p-sm-4">
                  <div className="mb-3">
                    <Search
                      placeholder="Search by email"
                      onSubmit={this.handleSearch}
                      initialValue={searchQuery}
                      pathToClearSearch="/summitRegistrants"
                    />
                  </div>
                  <div className="mb-4">
                    <SummitRegistrantsTable
                      appState={this.props.appState}
                      entityActions={this.props.entityActions}
                      query={query}
                      onEdit={this.handleEdit}
                    />
                  </div>
                </div>
              </div>
              <SummitRegistrantsDialog
                summitRegistrant={this.state.editSummitRegistrant}
                onSave={this.handleSaveDialog}
                onCancel={this.handleCancelDialog}
                appState={this.props.appState}
              />
            </Page>
          )}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/SummitRegistrants/SummitRegistrants.tsx